export default function initNewsletterForm() {
  Alpine.data('newsletterForm', (recaptchaKey = '') => ({
    open: false,
    invalid: false,
    submitting: false,
    email: '',
    recaptchaToken: '',
    recaptchaKey,
    onSubmit(event: Event) {
      event.preventDefault();
      // @ts-ignore
      const recaptchaEnabled = typeof grecaptcha !== 'undefined' && typeof grecaptcha.enterprise !== 'undefined' && typeof grecaptcha.enterprise.execute === 'function';
      const email = this.$el.querySelector("input[name='email']") as HTMLInputElement;
      if (email && !this.validEmail(email.value.trim())) {
        this.invalid = true;
      } else if (recaptchaEnabled) {
        this.submitting = true;
        // @ts-ignore
        grecaptcha.enterprise.ready(async () => {
          // @ts-ignore
          this.recaptchaToken = await grecaptcha.enterprise.execute(this.recaptchaKey, { action: 'newsletter' });
          this.triggerSubmit();
        });
      } else {
        this.triggerSubmit();
      }
    },
    triggerSubmit() {
      this.submitting = true;
      const form = this.$el as HTMLFormElement;
      const formData = new FormData(form);
      if (this.recaptchaToken !== '') {
        formData.set('g-recaptcha-response', this.recaptchaToken);
      }
      fetch('/', {
        method: 'POST',
        body: formData,
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        redirect: 'manual',
      })
        .then(() => {
          this.openSuccessDialog();
        })
        .catch(() => {
          this.submitting = false;
        });
    },
    openSuccessDialog() {
      this.open = true;
      this.email = '';
      document.body.style.overflowY = 'hidden';
      this.submitting = false;
    },
    closeSuccessDialog() {
      this.open = false;
      document.body.style.overflowY = 'initial';
    },
    validEmail(email: string) {
      const re = /^[a-zA-Z0-9.!#$%&'*+//=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
      return email !== '' && re.test(email.toLowerCase());
    },
    init() {
      this.$watch('email', (value, oldValue) => {
        if (value === '') {
          this.invalid = false;
        } else if (value !== oldValue) {
          this.invalid = !this.validEmail(value);
        }
      });
    },
  }));
}
